export const capitalizeFirstChar = (input: string | null | undefined) =>
{
    if (!input)
    {
        return input;
    }

    return `${input[0].toUpperCase()}${input.substring(1)}`;
};